import React, { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import * as actionCommon from "../../store/actions/commonActions"
import { Link } from "gatsby"
import Box from "@material-ui/core/Box"
import { FiBell } from "react-icons/fi"

import OutsideClick from "../OutsideClick/OutsideClick"
const NotificationIcon = props => {
  const { userNotifications } = useSelector(state => ({
    userNotifications: state.common.userNotifications,
  }))

  const dispatch = useDispatch()
  const handleClickOutsideAction = () => {
    userNotifications
      ? dispatch(actionCommon.userNotificationsPop(false))
      : false
  }
  return (
    <OutsideClick outsideAction={handleClickOutsideAction}>
      <Fragment>
        <Link
          className="nav-link dropdown-toggle no-caret"
          to="/"
          role="button"
          onClick={props.NotificationClickFun}
        >
          <Box component="span" className="feather-icon">
            <FiBell />
          </Box>
          <Box component="span" className="badge-wrap">
            <Box
              component="span"
              className="badge badge-primary badge-indicator badge-indicator-sm badge-pill pulse"
            ></Box>
          </Box>
        </Link>
      </Fragment>
    </OutsideClick>
  )
}

export default NotificationIcon
